import { createSlice } from '@reduxjs/toolkit';

export const paymentserviceSlice = createSlice({
    name: 'payment',
    initialState: {
        paymentCardDetails: '',
        SavedCardPaymentData: "",
        PaymentFrom: "",
        deviceTax: "",
        deviceTotal: "",
        deviceSubTotal: "",
        planDetails: {},
        getCompanyAddress:[]
    },
    reducers: {
        setPaymentCardDetails: (state, action) => {
            state.paymentCardDetails = action.payload;
        },
        setSavedCardPaymentData: (state, action) => {
            state.SavedCardPaymentData = action.payload;
        },
        setPaymentFrom: (state, action) => {
            state.PaymentFrom = action.payload;
        },
        setPlanDetails: (state, action) => {
            state.planDetails = action.payload;
        },
        setDeviceTax: (state, action) => {
            state.deviceTax = action.payload;
        },
        setDeviceTotal: (state, action) => {
            state.deviceTotal = action.payload;
        },
        setDeviceSubTotal: (state, action) => {
            state.deviceSubTotal = action.payload;
        },
        setCompanyAddress: (state, action) => {
            state.getCompanyAddress = action.payload;
        },
    }
});

export const {
    setPaymentCardDetails,
    setSavedCardPaymentData,
    setPaymentFrom,
    setPlanDetails,
    setDeviceTax,
    setDeviceTotal,
    setDeviceSubTotal,
    setCompanyAddress
} = paymentserviceSlice.actions

export default paymentserviceSlice.reducer;